import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {
    addFromColumn,
    sortNumber,
} from '../shared/functions';
import {getGetHeaders} from '../shared/serverFunctions';
import {setDefaultTableSort, getTableState, filterCaseInsensitive} from '../shared/tableFunctions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import ReactTable from 'react-table';
import {CSVLink} from 'react-csv';
import {RESOURCES as reportsResources} from '../fuseReportsResourceMap';
import '../shared/react-table.css';
import {commonStyles} from '../shared/styles';
import {tableStyles} from '../shared/styles-table';
import FlatButton from "material-ui/FlatButton";
import ExportIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import TableIcon from 'material-ui/svg-icons/action/receipt';
import Config from '../messages';

/**
 * Class for retrieving and displaying Inventory Transfer Lookup Summary in a single table
 *
 */
class InventoryTransferLookupReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reportName: 'Inventory Transfer Lookup',
            summaryList: [],
            summaryTableData: [],
            summaryTableHeaders: [
                {label: 'Product Name', key: 'product_name'},
                {label: 'Product ID', key: 'product'},
                {label: 'Category Name', key: 'category_name'},
                {label: 'Qty', key: 'qty'},
            ],
            message: null,
            summaryComplete: false,
        };
        this.handleExportClick = this.handleExportClick.bind(this);
        this.handleSortOrFilterChange = this.handleSortOrFilterChange.bind(this);
    }

    componentWillMount() {
        this.fetchData();
    }

    componentWillReceiveProps(nextProps) {
        if (
            nextProps.transferId !== this.props.transferId
        ) {
            this.setState({
                summaryList: [],
                summaryComplete: false,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.transferId !== this.props.transferId
        ) {
            this.fetchData();
        }
    }

    /* API Calls ------------------------------ */

    /**
     * Get Product data for a specified Transfer ID
     *
     */
    fetchData() {
        // Assemble the URI
        const params = {
            transfer_id: this.props.transferId,
        };
        const resource = reportsResources.TransferItemTotals.GET_LIST(params);

        const tokenStatus = checkTokenStatus(null);
        if (tokenStatus.expired) {
            return;
        }

        axios({
            method: 'get',
            url: resource.uri,
            headers: getGetHeaders()
        }).then((result) => {
            if (result.data && result.data.payload) {
                this.processData(result.data.payload);
            } else {
                this.processData(null);
            }
        }).catch((error) => {
            let message = Config.fuse.error.error + this.state.reportName + '.';
            if (error.response) {
                // Server response outside 2xx
                if (error.response.data && error.response.data.error) {
                    message = Config.fuse.error.error + this.state.reportName + ': ' + error.response.data.error;
                }
            } else if (error.request) {
                // No response
                message = Config.fuse.error.no_response + this.state.reportName + '.';
            } else {
                console.log('Error', error.message);
            }
            this.setState({
                summaryList: [],
                summaryTableData: [],
                summaryComplete: false,
            }, () => {
                if (typeof this.props.onError === 'function') {
                    this.props.onError(message);
                }
            });
        });
    }

    /* Data Processing ------------------------------ */

    /**
     * Store results
     *
     * @param data
     */
    processData(data) {

        let summaryList = [];

        if (data && data.length > 0) {
            let resultsTotal = data.length;
            if (resultsTotal) {
                for (let i = 0; i < resultsTotal; i++) {
                    let result = data[i];
                    const row = {
                        category_name: (result.category_name) ? result.category_name : '(None)',
                        product: (result.product) ? result.product : '(None)',
                        product_name: (result.product_name) ? result.product_name : '(None)',
                        qty: (result.qty) ? result.qty : 0
                    };
                    summaryList.push(row);
                }
            }
        }

        // Finalize table data
        this.setState({
            summaryList: summaryList,
            summaryTableData: summaryList,
            summaryComplete: true,
        }, () => {
            this.props.onSummaryComplete(true);
        });
    }

    /* Table Building ------------------------------ */

    /**
     * Update selected table data based on sort
     *
     * @param event
     * @param table
     */
    handleSortOrFilterChange(event, table) {
        const tableData = getTableState(table);
        if (tableData && tableData.length > 0) {
            this.setState({
                summaryTableData: tableData
            });
        }
    }

    /**
     * Handle event to retrieve current state of table data
     *
     * @param event
     */
    handleExportClick = (event) => {
        // CSVLink handles generation and export of CSV
    };

    /* Table Display ------------------------------ */

    render() {

        const {
            system
        } = this.props;

        const {
            summaryList,
            summaryTableData,
            summaryTableHeaders,
            summaryComplete,
        } = this.state;

        const defaultSort = setDefaultTableSort('product_name');

        // ReactTable headers and columns for Table
        const tableColumns = [
            {
                Header: '',
                columns: [
                    {
                        Header: 'Product Name',
                        accessor: 'product_name',
                    },
                    {
                        Header: 'Product ID',
                        accessor: 'product',
                    },
                    {
                        Header: 'Product Category',
                        accessor: 'category_name',
                    },
                    {
                        Header: 'Piece Qty',
                        accessor: 'qty',
                        sortMethod: (a, b) => sortNumber(a, b),
                        filterable: false,
                        Footer: (
                            <span style={tableStyles.footer}>
                                {addFromColumn(summaryTableData, 'qty')}
                            </span>
                        ),
                        style: tableStyles.right
                    }
                ]
            }
        ];

        return (
            <div>
                {summaryComplete &&
                <div className="reports-table-container">

                    {/* Table Header: Inventory Transfer Lookup */}
                    <div className="reports-table-title table-table-header">
                        <div className="btn-report-container report-header-button-container">
                            {/* Export Inventory Transfer Lookup */}
                            <FlatButton
                                primary
                                type="button"
                                label=""
                                style={commonStyles.headerButton}
                            >
                                <ExportIcon style={commonStyles.headerButtonIcon}/>
                                <CSVLink
                                    data={summaryTableData}
                                    headers={summaryTableHeaders}
                                    filename={'Inventory-Transfer-Lookup-' + system + '.csv'}
                                    onClick={(e) => this.handleExportClick(e)}
                                    target="_blank"
                                    style={commonStyles.headerButtonLink}
                                >
                                    Export Inventory Transfer Lookup
                                </CSVLink>
                            </FlatButton>
                        </div>
                        <h3 className="table-table-header-title">
                            <TableIcon style={commonStyles.summaryIcon}/>
                            <span>Inventory Transfer Lookup</span>
                        </h3>
                    </div>

                    {/* Table: Inventory Transfer Lookup */}
                    <ReactTable
                        key="table-inventory-transfer-lookup"
                        data={summaryList}
                        columns={tableColumns}
                        defaultPageSize={10}
                        showPagination={true}
                        defaultSorted={defaultSort}
                        filterable
                        defaultFilterMethod={filterCaseInsensitive}
                        onSortedChange={(e) => this.handleSortOrFilterChange(e, this.reactTable)}
                        onFilteredChange={(e) => this.handleSortOrFilterChange(e, this.reactTable)}
                        ref={(r) => this.reactTable = r}
                        resizable={false}
                        minRows={1}
                        className="-striped no-print"
                    />
                    <ReactTable
                        key="table-inventory-transfer-lookup-print"
                        data={summaryTableData}
                        columns={tableColumns}
                        defaultPageSize={10000}
                        showPagination={false}
                        defaultSorted={defaultSort}
                        filterable
                        resizable={false}
                        minRows={1}
                        className="print-only"
                    />
                </div>
                }
            </div>
        )
    }
}

InventoryTransferLookupReport.propTypes = {
    addField: PropTypes.bool,
    onDisplayMessage: PropTypes.func,
    onError: PropTypes.func,
    onSummaryComplete: PropTypes.func,
    transferId: PropTypes.string,
    system: PropTypes.string,
};

InventoryTransferLookupReport.defaultProps = {
    addField: true,
    transferId: null,
};

export default InventoryTransferLookupReport;



// WEBPACK FOOTER //
// ./src/Fuse/components/InventoryTransferLookupReport.js